import { levelSelectors } from '~/store';
// ---- internal imports ----

import { LEVEL_CONTINUE_FAILED } from '../actionTypes';
// ---- parent imports ----

import setupLevel from './setupLevel';
// ---- local imports ----


function continueFailedLevel() {
	return async (dispatch, getState) => {
		
		const failedLevel = levelSelectors.getLevelNumber(getState());

		const missions = setupLevel(getState(), failedLevel);
		
		dispatch({
			type: LEVEL_CONTINUE_FAILED,
			missions
		});

	};
}


export default continueFailedLevel;
